export default __webpack_public_path__ + "static/media/team8.14273114.png";